import { render, staticRenderFns } from "./promotion-package-form.vue?vue&type=template&id=46a3655e&"
import script from "./promotion-package-form.vue?vue&type=script&lang=js&"
export * from "./promotion-package-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports